export class BillingSearch { 
    itemStartDate: Date;
    itemEndDate: Date;
    userEmailId: string;
    cities?: any[];
}